import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-1_XX3Z3lbK1",
  ClientId: "7er9p29qv8ea0bj4049us1j86",
};

export default new CognitoUserPool(poolData);
